import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertContextEnum } from '../../../../../../modules/src/lib/core/enums/alert-context.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { InviteApiController } from '../../../api-controllers/invite.api-controller';
import { InviteModel } from '../../../../../../../../common/dist/angular/models/invite.model';
import { LoggingService } from '../../../../../../modules/src/lib/core/services/logging.service';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-list-invites',
  templateUrl: './list-invites.component.html',
  styleUrls: ['./list-invites.component.scss'],
  standalone: false,
})
export class ListInvitesComponent implements OnInit, OnDestroy {
  alertContextEnum = AlertContextEnum;

  isLoading = true;
  showHasBeenRefreshed = true;

  invites: InviteModel[];

  constructor(private readonly apiController: InviteApiController,
              private readonly router: Router,
              private readonly loggingService: LoggingService,
              public readonly authService: AuthService,
              private readonly route: ActivatedRoute) {
  }

  ngOnDestroy(): void {
  }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  async acceptInvite(inviteModel: InviteModel) {
    try {
      await this.apiController.redeem(inviteModel.id);
      this.refreshAccessToken();
      location.reload();
      return await this.router.navigateByUrl('/');
    } catch (e) {
      this.loggingService.error('Error accepting invite', e);
    }
  }

  refreshAccessToken() {
    return this.authService.getAccessTokenSilently({
      authorizationParams: {
        audience: environment.auth0Audience,
        scope: 'openid profile email read:all',
      },
    }).subscribe(value => {
    }, error => {
      this.authService.getAccessTokenWithPopup({
        authorizationParams: {
          audience: environment.auth0Audience,
          scope: 'openid profile email read:all',
        },
      }).subscribe(value => {
      }, error => {
      });
    });
  }

  async refresh(): Promise<void> {
    this.isLoading = true;
    this.showHasBeenRefreshed = false;

    this.invites = await this.apiController.listForUser();
    // for (const clientQuestionnaire of this.clientQuestionnaires) {
    //   await this.clientQuestionnaireStore.save(clientQuestionnaire.id, clientQuestionnaire);
    // }

    this.isLoading = false;
    this.showHasBeenRefreshed = true;

    setTimeout(() => {
      this.showHasBeenRefreshed = false;
    }, 3000);
  }

}
